import React from "react";
import { Header } from "semantic-ui-react";
import PropTypes from "prop-types";

const PrestamoDetailHeader = ({ credito }) => {
  return (
    <Header as="h2" color="blue">
      {credito.nombreProducto}
    </Header>
  );
};

PrestamoDetailHeader.propTypes = {
  credito: PropTypes.object.isRequired,
};

export default PrestamoDetailHeader;
